var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C13.5759 24 15.1363 23.6896 16.5922 23.0866C18.0481 22.4835 19.371 21.5996 20.4853 20.4853C21.5996 19.371 22.4835 18.0481 23.0866 16.5922C23.6896 15.1363 24 13.5759 24 12C24 10.4241 23.6896 8.86371 23.0866 7.4078C22.4835 5.95189 21.5996 4.62902 20.4853 3.51472C19.371 2.40042 18.0481 1.5165 16.5922 0.913445C15.1363 0.310389 13.5759 -2.34822e-08 12 0C8.8174 4.74244e-08 5.76516 1.26428 3.51472 3.51472C1.26428 5.76515 0 8.8174 0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C5.76516 22.7357 8.8174 24 12 24ZM10.3773 6.65333L17.9027 10.8347C18.1104 10.9502 18.2835 11.1191 18.404 11.324C18.5245 11.5289 18.5881 11.7623 18.5881 12C18.5881 12.2377 18.5245 12.4711 18.404 12.676C18.2835 12.8809 18.1104 13.0498 17.9027 13.1653L10.3773 17.3467C10.1337 17.4821 9.85884 17.5515 9.58008 17.5481C9.30132 17.5446 9.02831 17.4683 8.78809 17.3269C8.54787 17.1854 8.34878 16.9836 8.21055 16.7416C8.07232 16.4995 7.99974 16.2254 8 15.9467V8.05333C7.99974 7.77455 8.07232 7.50054 8.21055 7.25845C8.34878 7.01636 8.54787 6.81458 8.78809 6.67312C9.02831 6.53165 9.30132 6.45541 9.58008 6.45194C9.85884 6.44847 10.1337 6.51789 10.3773 6.65333Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.d96e970abe253e06248ec6563a9fcc84.svg";
export { ForwardRef as ReactComponent };